<style scoped lang="scss">
$font_color: rgba(31, 31, 31, 0.49);
$border_color: #ebeef5;
.policy_index {
    // width: 1310px;
    margin: 0 auto;
}
.policy_search {
    box-sizing: border-box;
    height: 63px;
    display: flex;
    border: 1px solid $border_color;
    padding-left: 40px;
    align-items: center;
    margin-bottom: 20px;
    button {
        width: 100px;
        height: 34px;
        line-height: 8px;
        margin-right: 30px;
    }
}
.policy_search_box {
    font-size: 12px;
    color: $font_color;
    margin-right: 30px;
    span {
        margin-right: 10px;
    }
}
.policy_table {
    font-size: 12px;
    color: $font_color;
    box-sizing: border-box;
    border: 1px solid $border_color;
    border-bottom: none;
    h3 {
        height: 42px;
        line-height: 42px;
        box-sizing: border-box;
        padding-left: 10px;
    }
}
.policy_page{
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
@import '../../common/scss/color.scss';

.crumbs {
  padding-left: 6px;
  border-left: 3px solid #bbb;
  margin: 14px 10px;
  background-color: #f5f5f5;
  height: 37px;
  line-height: 37px;
  font-size: 14px;
  .direct-tip {
    color: #333;
  }
  .direct-dir {
    color: $mainColor;
    &:hover {
      text-decoration: underline;
    }
  }
  .direct-sub-dir {
    color: #666;
  }
}
.el-select-dropdown__item{
  width:220px !important;
}
</style>
<style lang='scss'>
.policy_index {
    .el-select {
        width: 220px;
    }
    .el-table th {
        background: #f7f7f7 !important;
        color: #333 !important;
        font-weight: 500;
    }
    .el_table td {
        color: rgba(31, 31, 31, 0.49) !important;
    }
    .el-table--enable-row-transition .el-table__body td {
        transition: background-color 0.25s ease;
    }
    .el-table th > .cell {
        line-height: 34px;
    }
    .el-table td,
    .el-table th {
        padding: 16px 0;
    }
    .el-table__empty-block{
      max-height: 100px !important;
    }
    .el-select .el-input .el-select__caret{
      line-height: 34px;
    }

}
</style>

<template>
  <div class="policy_index">
    <div class="crumbs">
    <span class="direct-tip">当前位置：</span>
    <a class="direct-dir" :href="'/iad_puton/planlist'">投放明细</a>
    <!-- <router-link class="direct-dir" :to="{name: 'materialdata' , query : {PutOnId : PutOnId }}">>素材数据</router-link> -->
    <a class="direct-dir" :href="'/IAD_MaterialData/MaterialInit#/MaterialInit?PutOnId='+PutOnId">>素材数据</a>

    <span class="direct-sub-dir">>分媒体数据</span>
   </div>
    <div class="policy_search">
      <div class="policy_search_box">
        <span>
          广告位ID
        </span>
        <template>
          <el-select v-model="oplicyId" clearable filterable placeholder="请选择">
            <el-option v-for="item in oplicyIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </div>
      <div class="policy_search_box">
        <span>
          广告位名称
        </span>
        <template>
          <el-select v-model="oplicyName" clearable filterable placeholder="请选择" >
            <el-option v-for="item in oplicyNameOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </div>
      <el-button type="primary" @click='searchClick'>搜索</el-button>
      <el-button type="primary" @click="checketOut">导出</el-button>
    </div>
    <div class="policy_table">
      <h3>
        <i class="el-icon-edit-outline"></i>
        素材数据（共{{total}}条）
      </h3>
      <template>
        <el-table :data="tableData" v-loading="loading" :empty-text='emptyText' style="width: 100%">
          <el-table-column property="SourceId" label="广告位ID" align='center' min-width="90">
          </el-table-column>
          <el-table-column property="SourceName" label="广告位名称" align='center' min-width="150">
          </el-table-column>
          <el-table-column property="ExposureCount" label="曝光" align='center' min-width="90">
          </el-table-column>
          <el-table-column property="ClickPvCount" label="计费点击" align='center' min-width="90">
          </el-table-column>
          <el-table-column property="CTR" label="点击率" align='center' min-width="90">
          </el-table-column>
          <el-table-column property="InCome" label="消耗" align='center' min-width="90">
          </el-table-column>
          <el-table-column property="ArpuRate" label="发卷arpu" align='center' min-width="90">
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="policy_page">
        <el-pagination :current-page="pageIndex" background :page-size="20" @current-change="handleCurrentChange" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
  </div>
</template>

<script>
// 面包屑
import crumbs from "../public/crumbs/crumbs";
import { mediaInfor } from "api/policyservers";
export default {
    data() {
        return {
            operateType: "素材数据",
            oplicyIdOptions: [
                {
                    value: 0,
                    label: 21323
                },
                {
                    value: 1,
                    label: 21323
                },
                {
                    value: 2,
                    label: 21323
                }
            ],
            oplicyId: "",
            oplicyNameOptions: [],
            oplicyName: "",
            total: 0,
            tableData: [],
            loading: false,
            emptyText: "当前暂无数据",
            pageIndex: 1,
            PutOnId: '',
            MaterialId: '',
            StatisDate:""//时间
        };
    },

    components: {
        crumbs
    },

    computed: {},

    created() {
        this.loading= true
        this.PutOnId= this.$route.query.PutOnId,
        this.MaterialId= this.$route.query.MaterialId,
        this.StatisDate = this.$route.query.StatisDate;
        this.ajaxInfo()
    },

    updated() {},

    mounted() {},

    destroyed() {},

    methods: {
      handleCurrentChange(val) {
            this.loading = true;
            this.pageIndex = val * 1;
            this.ajaxInfo();
        },
        searchClick() {
            this.loading = true;
            this.ajaxInfo();
        },
        checketOut() {
          window.location.href = `/IAD_MediaData/Export?PutOnId=${this.PutOnId}&MaterialId=${this.MaterialId}&SourceId=${this.oplicyId}&SourceName=${this.oplicyName}&StatisDate=${this.StatisDate}`
        },
        ajaxInfo() {
            mediaInfor({
                PutOnId: this.PutOnId,
                MaterialId : this.MaterialId,
                page: this.pageIndex,
                SourceId: this.oplicyId,
                SourceName: this.oplicyName,
                StatisDate: this.StatisDate
            })
                .then(res => {
                    this.loading = false;
                    if (res.TotalNum == 0) {
                        this.tableData = [];
                        this.oplicyIdOptions = [];
                        this.oplicyNameOptions = [];
                        this.total = res.data.TotalNum;
                    } else {
                        this.total = res.data.TotalNum;
                        this.tableData = res.data.Items;
                        this.oplicyIdOptions = [];
                        this.oplicyNameOptions = [];
                        res.data.Items.map((ele, index) => {
                            this.oplicyIdOptions.push({
                                lable: index,
                                value: ele.SourceId
                            });
                            this.oplicyNameOptions.push({
                                lable: index,
                                value: ele.SourceName
                            });
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.tableData = [];
                    this.oplicyIdOptions = [];
                    this.oplicyNameOptions = [];
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/policy-data/media-data.vue